export default{
	name : 'operator_dialog',
	props:{
		show : Boolean
	},
	data () {
		return {}
	},
	methods : {
		close() {
			this.$emit('close');
		},
		cmcc() {
			// window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dservice.ydkd%26type%3dparams%26params%3dopenId&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=10;31;1';
		},
		ctcc() {
			// window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dservice.dyyw%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=10;32;1';
		},
		ltcc() {
			// window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dservice.ltyy%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=10;33;1';
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/operator_dialog/operator_dialog.controller.js